import {
  BoosterWagerBonus,
  FreeHUSDLockBonus,
  FreeLuckyspinBonus,
  NoWageringCashBonus,
  HUSDUnLockBoosterBonus,
  LevelUpBonus,
  UserBonus,
  WageringConditionBonus,
} from 'config/types/bonus/userBonus'
import Column from 'layout/Components/Column'
import React from 'react'
import SimpleUsedBonusContent from './SimpleUsedBonusContent'
import UsedWageringBonusContent from './UsedWageringBonusContent'

interface BonusItemProps {
  bonus: UserBonus
  isShowMonochrome?: boolean
}

const UsedBonusContent: React.FC<BonusItemProps> = ({ bonus, isShowMonochrome }) => {
  return (
    <Column height="100%">
      {(bonus instanceof LevelUpBonus ||
        bonus instanceof HUSDUnLockBoosterBonus ||
        bonus instanceof FreeHUSDLockBonus ||
        bonus instanceof NoWageringCashBonus ||
        bonus instanceof FreeLuckyspinBonus ||
        bonus instanceof BoosterWagerBonus) && <SimpleUsedBonusContent bonus={bonus} />}

      {bonus instanceof WageringConditionBonus && (
        <UsedWageringBonusContent bonus={bonus} isShowMonochrome={isShowMonochrome} />
      )}
    </Column>
  )
}

export default UsedBonusContent
